import script from "./AuthorizationRegisterView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationRegisterView.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationRegisterView.vue?vue&type=style&index=0&id=1d739661&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d739661"]])

export default __exports__